import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export function ProtectedAdminRoute() {
  const { hasPermission, loading } = useAuth();

  if (loading) return null;

  if (!hasPermission('admin.users.read')) {
    return <Navigate to="/accounts" replace />;
  }

  return <Outlet />;
}
